import { appReducer } from './reducers/app.reducer';
import { authReducer } from './reducers/auth.reducer';
import { devicesReducer } from './reducers/devices.reducer';
import { licensesReducer } from './reducers/licenses.reducer';
import { salesReducer } from './reducers/sales.reducer';

export const appReduceMap = {
  app: appReducer,
  auth: authReducer,
  devices: devicesReducer,
  licenses: licensesReducer,
  sales: salesReducer,
};
